import React, { Component } from 'react';
import Truncate from 'react-truncate';

class BrandCarouselItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemClassName: ''
    };
  }

  componentDidMount() {
    this.calculateFade();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isScrolled !== this.props.isScrolled) {
      this.calculateFade();
    }
  }

  getRef = (instance) => {
    this.ref = instance;
  }

  calculateFade = () => {
    if (this.ref) {
      const {
        width, left
      } = this.ref.getBoundingClientRect();
      const { outerWidth } = window;
      const halfWidth = (width / 2);
      const center = left + halfWidth;

      if (center + halfWidth <= outerWidth && center - halfWidth >= 0) {
        this.setState({ itemClassName: 'overlay-visible' });
      } else if (center + halfWidth < outerWidth || center - halfWidth > 0) {
        this.setState({ itemClassName: 'overlay-partly-visible' });
      }
    }
  }

  render() {
    const { name, image } = this.props;
    const { itemClassName } = this.state;

    return (
      <div ref={this.getRef} className="carousel-item">
        <a href={`/brands?brand=${name}`} className={`overlay ${itemClassName}`}>
          <Truncate lines={2} ellipsis={<span>...</span>}>
            {name}
          </Truncate>
        </a>
        <img src={image} alt={name} />
      </div>
    );
  }
}

export default BrandCarouselItem;



// WEBPACK FOOTER //
// ./src/components/common/home/carousels/brand-carousel-item.jsx